<template>
  <div class="header">
    <div class="header-wrap">
      <div class="logo">
        <router-link :to="{path:'/'}">
          <img src="@/assets/imgs/logo.png" alt />
        </router-link>
      </div>

      <el-menu default-active class="menu" mode="horizontal">
        <!-- <el-menu-item>首页</el-menu-item> -->
        <!-- <el-menu-item active-class="is-active" index="/contest">比赛</el-menu-item>
      <el-menu-item active-class="is-active" index="/train">训练</el-menu-item>
        <el-menu-item active-class="is-active">专题</el-menu-item>-->
        <router-link tag="li" active-class="is-active" class="el-menu-item" :to="{name:'index'}" index="0">首页</router-link>
        <router-link tag="li" active-class="is-active" class="el-menu-item" :to="{name:'contest'}" index="1">比赛</router-link>
        <router-link tag="li" active-class="is-active" class="el-menu-item" :to="{name: 'training'}" index="2">训练</router-link>
        <router-link tag="li" active-class="is-active" class="el-menu-item" :to="{name: 'classroom-index'}" index="3">专题</router-link>
        <!-- <el-menu-item>专题</el-menu-item> -->
        <template v-if="isLogin">
          <el-submenu index="1" class="right drop">
            <template slot="title">
              <el-avatar :src="require('../../assets/imgs/avatar.png')"></el-avatar>
            </template>
            <el-menu-item index="1-1">
              <i class="el-icon-user-solid"></i>
              {{ $store.getters.user.nickname }}
            </el-menu-item>
            <el-menu-item index="1-2" @click="toPersonal">
              <i class="el-icon-s-tools"></i>
              账号设置
            </el-menu-item>
            <router-link tag="el-menu-item" :to="{ name: this.adminPath }" index="1-3" v-if="$store.getters.permissions.length>0">
              <i class="el-icon-menu"></i>管理后台
            </router-link>
            <el-menu-item index="1-4" @click="signOut()" v-if="isLogin">
              <i class="el-icon-switch-button"></i>退出
            </el-menu-item>
          </el-submenu>
          <el-menu-item index="2" class="right" tag="el-menu-item" :to="{ name: 'notify' }" @click="toMessageCenter">
            <i class="el-icon-message"></i>消息
            <el-badge class="mark" :value="unReadCount" v-if="unReadCount" />
          </el-menu-item>
        </template>
        <template v-if="!isLogin">
          <el-menu-item @click="register" class="right">
            注册
          </el-menu-item>
          <el-menu-item v-if="!isLogin" @click="login" class="right">
            登录
          </el-menu-item>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { getToken, removeToken } from "@/utils/auth";
import { userInfo, logout, doLogin, toPersonal } from "@/api/user";
import { baseUrl } from "@/utils/constant";
import { mapGetters } from "vuex"
export default {
  data() {
    return {
      activeIndex: "1",
      isLogin: false,
      keyword: "",
      adminPath: "course-list",
      pathArr: {
        "course-list": "admin_course_manage",
        "user-manage": "admin_user",
        "system-roles": "admin_system"
      }
    };
  },
  created() {
    this.isLogin = getToken() ? true : false;
 
    // let arr = [];
    var permissions = this.$store.getters.permissions;
    var arr = [];
    if (permissions) {
      Object.keys(this.pathArr).forEach((item, index) => {
        if (permissions.indexOf(this.pathArr[item]) > -1) {
          arr.push(item);
        }
      });
      this.adminPath = arr[0] || "course-list";
    }
  },
  computed:{
    ...mapGetters([
      'user',
      'unReadCount'
    ])
  },
  watch: {
    
  },
  methods: {
    signOut() {
      const params = {
        redirect_uri: window.location.href
      }
      logout(params).then(res => {
        window.location = res.data;
      });
    },
    login() {
      const params = {
        redirect_uri: window.location.href
      }
      doLogin(params).then(res => {
        window.location.href = res.data;
      })
    },
    search() {
      if (this.keyword) {
        this.$router.push({
          path: "/app/search",
          query: { keyword: this.keyword }
        });
      }
    },
    toPersonal(){
      const params = {
        redirect_uri: window.location.href
      }
      toPersonal(params).then(res=>{
        window.open(res.data,'_blank')
      })
    },
    toMessageCenter() {
      window.open(baseUrl.UC_BASE_URL + '/personal/notification/list','_blank')
    }
  }
};
</script>

<style scoped>
.header {
  /* margin-bottom: 20px; */
  border-bottom: 1px solid #e6e6e6;
}
.header-wrap {
  width: 1200px;
  overflow: hidden;
  margin: 0 auto;
}
.logo {
  width: 210px;
  height: 100%;
  text-align: center;
  line-height: 60px;
  font-size: 20px;
  float: left;
}
.logo img {
  max-width: 210px;
  max-height: 50px;
  margin-right: 10px;
  vertical-align: middle;
}
.el-menu {
  width: 950px;
  float: right;
}
.el-menu.el-menu--horizontal {
  border-bottom: 0;
}
.drop {
  width: 150px;
}
.is-active {
  border-bottom: 2px solid #409eff;
}
.mark {
  position: absolute;
  top: -10px;
  right: 0;
}
</style>
